module.exports = __webpack_public_path__ + "img/0.68bd223c.jpg";